"use client"

import { useAuth } from "@/core/auth/client/AuthProvider"
import { updateFavoriteGames } from "@/features/casino/services"
import { useAuthStore } from "@/stores/userStore"
import { userUIStore } from "@/stores/userUIStore"

export function useGameFavorite() {
  const { session } = useAuth()
  const { account, updateFavoriteGames: persistFavorites } = useAuthStore()
  const { toggleLoginModal } = userUIStore()
  const favorites = Array.isArray(account?.favoriteGames)
    ? account.favoriteGames
    : []

  const isFavorite = (gameCode: string) => {
    return gameCode !== "" && favorites.includes(gameCode)
  }

  const toggleFavorite = async (gameCode: string) => {
    if (!gameCode) {
      return
    }

    if (!session?.user) {
      toggleLoginModal()
      return
    }

    const next = isFavorite(gameCode)
      ? favorites.filter((code) => code !== gameCode)
      : [...favorites, gameCode]
    persistFavorites(await updateFavoriteGames(next))
  }

  return { isFavorite, toggleFavorite }
}
